<template>
    <v-dialog
        v-model="deleteMemberCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="modelType==='DeleteBtn'"
                class="delete-btn"
                outlined
                light
                @click="openDialog"
            >
                Delete
            </v-btn>
            <v-icon
                v-if="modelType==='DeleteIcon'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-delete
            </v-icon>
        </template>
        <v-card id="delete_member_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="mt-5">
                    Are you sure you want to delete <b>{{ memberCode.member_code }}</b> form the Member code list?
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="deleteMemberCode"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    name: 'DeleteMemberCode',
    props: {
        modelType: {
            type: String,
            required: true
        },
        memberCode: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        deleteMemberCodeDialog: false,
    }),
    methods: {
        closedDialog() {
            this.deleteMemberCodeDialog = false;
        },
        openDialog() {
            this.deleteMemberCodeDialog = true;
            this.$emit('closed-dialog');
        },
        async deleteMemberCode() {
            delete this.memberCode.sendPrCenter;
            delete this.memberCode.sendPrExcavator;
            let data = [{ 
                ...this.memberCode,
                send_pr_center_YN: this.memberCode.send_pr_center ? 'Yes' : 'No',
                send_pr_excavator_YN: this.memberCode.send_pr_excavator ? 'Yes' : 'No'
            }];
            let result = await webtmsBackend.deleteMemberCode(data, this.$store.getters.company.cid);
            if(result.status === 'OK') {
                this.$store.commit('SET_COMPANY_MEMBER_CODES', result.memberCodes);
                this.closedDialog();
                this.$store.dispatch('setSnackbar', { text: 'Member code deleted successfully!' });
            }
            if(result.errors) {
                this.closedDialog();
                this.$store.dispatch('setSnackbar', { color:'error', text: result.results[0].err });
            }
        }
    }
};
</script>
<style>
</style>